export const validationPatterns = {
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  phoneNumber: /^[0-9]{10,15}$/,
  password: /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,}$/,
  URL: /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
};

export const blockInvalidChar = (e) =>
  ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

/**
 * Validates image file type and size
 * @param {File} file - The file to validate
 * @param {Object} options - Validation options
 * @param {string[]} options.allowedTypes - Array of allowed MIME types (default: ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'])
 * @param {number} options.maxSizeMB - Maximum file size in MB (default: 5)
 * @returns {Object} - { isValid: boolean, error: string|null }
 */
export const validateImageFile = (file, options = {}) => {
  const {
    allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/webp"],
    maxSizeMB = 5,
  } = options;

  if (!file) {
    return { isValid: false, error: "No file selected" };
  }

  // Validate file type
  if (!allowedTypes.includes(file.type.toLowerCase())) {
    const typeNames = allowedTypes
      .map((type) => type.replace("image/", "").toUpperCase())
      .join(", ");
    return {
      isValid: false,
      error: `Invalid file type. Please upload a ${typeNames} image.`,
    };
  }

  // Validate file size
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size > maxSizeBytes) {
    return {
      isValid: false,
      error: `File size too large. Please upload an image smaller than ${maxSizeMB}MB.`,
    };
  }

  return { isValid: true, error: null };
};
